@if (formGroup) {
    <form id="register-form" [formGroup]="formGroup" (ngSubmit)="save($event)" class="info-content-container">
        <div id="titleHeader" class="title-header flex-row">
            <span class="flex-1">{{ 'admin.faq.createFaqTitle' | translate }}</span>
            <button type="button" class="icon-button icon-close" (click)="goBackInFaq(currentItem)"></button>
        </div>
        <div class="scroll-container">
            <div class="content">
                <div class="information-container">
                    <div class="information-content">
                        <div class="flex-row">
                            <div class="card-cell flex-2">
                                <sag-ui-checkbox [checked]="!faqItem.content" (change)="changeChildren($event.checked)">
                                    {{ 'admin.faq.item.hasChildren' | translate }}
                                </sag-ui-checkbox>
                            </div>
                            <div class="card-cell flex-1">
                                <!-- <mat-checkbox *ngIf="!item.content" formControlName="hasGuidance" labelPosition="after">
                  {{ "admin.faq.item.hasGuidance" | translate }}
                </mat-checkbox> -->
                            </div>
                        </div>
                        @if (!isParent) {
                            <div class="flex-row">
                                <sag-ui-input
                                    class="card-cell flex-1"
                                    formControlName="videoLink"
                                    [label]="'Video Link'"
                                />
                            </div>
                        }
                        <div class="flex-row">
                            <sag-ui-select
                                class="card-cell flex-2"
                                formControlName="visibility"
                                [required]="true"
                                [label]="'admin.faq.item.visibility' | translate"
                            >
                                @for (option of visibilities; track option) {
                                    <sag-ui-option [value]="option">
                                        {{ 'admin.faq.item.visibility' + option | translate }}
                                    </sag-ui-option>
                                }
                            </sag-ui-select>
                            <div class="card-cell flex-3"></div>
                        </div>
                    </div>
                </div>
                @if (IS_TRS_PROJECT) {
                    @if (faqItem.content) {
                        <div class="flex-row card-cell">
                            <app-drop-zone [multiple]="false" formControlName="documents" />
                        </div>
                    }
                }
                @for (language of languages; track language) {
                    <div class="information-container">
                        <div class="statistics-title statistics-title--full">
                            {{ 'generic.languages.' + language | translate }}
                        </div>
                        <div class="information-content">
                            <div class="flex-row">
                                <sag-ui-input
                                    class="card-cell flex-1"
                                    [formControl]="title(language)"
                                    [required]="language === 'en'"
                                    [label]="'admin.faq.item.title' | translate"
                                />
                                <div class="card-cell flex-1"></div>
                            </div>
                            @if (faqItem.content) {
                                <div class="flex-row">
                                    <div
                                        class="card-cell label-input label-input--editor flex-4"
                                        [ngClass]="{ required: language === 'en' }"
                                    >
                                        <app-editor
                                            id="content-{{ language }}"
                                            label="{{ 'admin.faq.item.content' | translate }}"
                                            [formControl]="content(language)"
                                        />
                                    </div>
                                    <div class="card-cell flex-1"></div>
                                </div>
                            }
                            @if (IS_PRODUCT_SAFETY_PROJECT) {
                                <div class="flex-row card-cell">
                                    @if (language === 'de') {
                                        <app-drop-zone [multiple]="false" formControlName="documentsDE" />
                                    } @else {
                                        <app-drop-zone [multiple]="false" formControlName="documentsEN" />
                                    }
                                </div>
                            }
                        </div>
                    </div>
                }
            </div>
        </div>
    </form>
}
